import {Canvas, FabricImage, Line} from "fabric";

const getImageDimensions = (base64Image: string) => new Promise<{ width: number, height: number }>((resolve) => {
    const i = new Image();
    i.onload = () => {
        resolve({ width: i.width, height: i.height });
    }
    i.src = base64Image;
})

export const addGridToBase64Image = async (base64Image: string, gridOffset = 40) => {
    const canvas = new Canvas(undefined, await getImageDimensions(base64Image));
    const img = await FabricImage.fromURL(base64Image, { crossOrigin: 'anonymous' });

    img.set({ left: 0, top: 0 });
    canvas.add(img);

    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
    const lineOptions = {
        stroke: 'red',
        strokeWidth: 2
    };

    canvas.add(new Line([0, gridOffset, canvasWidth, gridOffset], lineOptions));
    canvas.add(new Line([0, canvasHeight - gridOffset, canvasWidth, canvasHeight - gridOffset], lineOptions));
    canvas.add(new Line([gridOffset, 0, gridOffset, canvasHeight], lineOptions));
    canvas.add(new Line([canvasWidth - gridOffset, 0, canvasWidth - gridOffset, canvasHeight], lineOptions));

    return canvas.toDataURL();
};